import Axios from 'axios';
import { inRange } from 'lodash';

/**
 * Recognize this range of http codes as success
 * @type {number[]}
 */
const SUCCESS_CODE_LIMITS = Object.freeze([200, 300]);

/**
 * Validate a response status code
 * @param {number} status - The status code
 * @return {boolean} The result
 */
export function validateStatus(status) {
    return inRange(status, ...SUCCESS_CODE_LIMITS);
}

/**
 * Create an Axios instances with basic xsrf functionality baked in
 */
export default Axios.create({
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
    headers: {
        HTTP_X_REQUESTED_WITH: 'XMLHttpRequest',
    },
    withCredentials: true,
});
